import { render } from "./ReleaseHistory.vue?vue&type=template&id=3fae173f&scoped=true"
import script from "./ReleaseHistory.vue?vue&type=script&lang=js"
export * from "./ReleaseHistory.vue?vue&type=script&lang=js"

import "./ReleaseHistory.vue?vue&type=style&index=0&id=3fae173f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fae173f"]])

export default __exports__